<template>
  <html>
    <head> </head>
    <body>
      <navbar></navbar>
      <div class="top">
        <nav class="navbar navbar-light bg-light">
          <form class="container-fluid justify-content-start" v-if="sales.hubspot_id !== undefined">
            <div>
              <p> &lt; </p>
            </div>

            <!--p style="margin-left: auto">เลขที่สั่งซื้อ : {{ sales.hubspot_id }}</!--p-->

            <div class="line-c">
              <hr class="new4" />
            </div>
          </form>
        </nav>
      </div>
      <div class="row bg-white s order-history"  v-if="sales.hubspot_id !== undefined">
        <div>

          <span class="name-now">{{ salesDate }}</span>
          <span class="name-product">{{ sales.dealname }}</span>
          

          <span class="name-price">{{ sales.point  | numFormat('0,000,000') }} คะแนน  ({{ sales.status | translateStatus }})</span>
        </div>
      </div>
      <div class="" style="min-width:100%" v-if="sales.hubspot_id !== undefined">
        <div class="row">
          <div class="col"  style="min-width:100%" v-for="(product, index) in sales.products"
              :key="product._id">
            <a
              @click="goto('Product02', index)"
              class="row bg-white"
              
            >
              <div class="orderList">
                <img
                  class="img-product"
                  :src="'https://api.loyaltyhub.me/public/' + product.image"
                  v-if="product.image !== undefined"
                />

                <span class="name-product">{{ product.name }} </span>
                <span class="name-category" v-if="product.category !== undefined">{{
                  product.category
                }}</span>
                <span class="name-price">ราคา  {{ product.price  | numFormat('0,000,000.00') }}  บาท</span>

            

                <span class="name-price">จำนวน {{product.quantity}} ชิ้น </span>
                <span class="name-price">รวม    {{ product.quantity*product.price  | numFormat('0,000,000.00') }} บาท</span>
 
              </div>
             
            </a>
             
             
          </div>
          <div>
                <span class="name-price" >รวมทั้งหมด    {{ sales.amount  | numFormat('0,000,000.00') }} บาท</span>
             </div>
         
        </div>
        
        </div>
      <div
        v-if="sales.shipping_name !== undefined"
      >
        <div>
          <span class="wordorder">จัดส่ง</span>
        </div>
        <div class="det">
          <img
            class="iconthreet"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-pin-red.png"
          />
          <br>
          <span class="name-customer"
            >
            <pre>          {{ sales.shipping_name }}
            {{ sales.shipping_phone }}
            {{ sales.shipping_address }}
            {{ sales.shipping_state }}
            {{ sales.shipping_postcode }}</pre>
            </span
          >
        </div>
        <div  v-if="sales.hubspot_id !== undefined">
          <span class="wordorder">ข้อมูลจัดส่ง</span>
        </div>

        <div class="det" v-if="sales.tracking_information !== undefined ">
          <img
            class="iconthreet"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-pin-red.png"
          />
          <br>
          <span class="name-customer"
            >
            <pre>            {{ sales.tracking_information.company }}
            {{ sales.tracking_information.tracking_code }}
            {{ sales.tracking_information.tracking_date }}</pre>
            </span
          >
        </div>
        <div class="lastrow"></div>
      </div>
    </body>
  </html>
</template>
<script>
import { DateTimeFunc } from "../libs/constant.js";
import Navbar from "./navbar";
export default {
  name: "OrderHistory",
  components: {
    navbar: Navbar,
  },
  data() {
    return {
      //sales: {},
    };
  },
  filters:{
    translateStatus: function(val){
      if(val == "Completed" || val == "Approved"){
        return "สำเร็จ";
      }else if(val == "Cancelled" || val == "Cancelled"){
        return "ยกเลิก";
      }else{
         return "กำลังดำเนินการ";
      }
    }
  },
  computed: {
    
    salesDate() {

        //return DateTimeFunc.reformatDate(this.sales.createdAt|| new Date());
      let sd = this.sales.createdAt || new Date()
      let ymd = sd.substring(0, 10).split("-");
      //return "";
      let month = DateTimeFunc.TH_MONTH(ymd[1]);
      return ymd[2] + " " + month + " " + (parseInt(ymd[0]) + 543);//+' '+val.substring(11, 19);

    },
    sales(){
      /*return this.$store.state.orderList.filter(item=>{
        console.log(item);
        return item._id == this.$route.params.orderId ;
      })[0];
      */
      return this.$store.state.orderList[0];
    }
  },
  mounted() {
    console.log(this.$route);
    // console.log(this.$router);
    console.log(this.sales);
    
      //return this.$store.state.orderList[this.$route.params.orderId || 0];
      
      /*
      return this.$store.dispatch("getSaleInformation",this.$store.state.orderList[this.$route.params.orderId])
      .then(response=>{
          //console.log(response);
          this.sales = response;
       });
       */
    },

  watch:{
      sales:{
          handler(val){
              console.log(val);
            }
        }
    }
};
</script>
<style scoped>
@import "./Css/style.css";
.name-company {
  color: #7f8285a9;
  font-size: 13px;
  padding: 5px 5px 5px 10px;
}

.name-customer {
      font-family: 'Prompt';
  color: #7f8285a9;
  font-size: 0.8em;
  padding: 0px 5px 5px 10px;
}
.name-locat {
      font-family: 'Prompt';
  color: #7f828596;
  margin-top: 50px;
  margin-bottom: 0px;
  font-size: 16px;
  margin-left: 13px;
}
.det {
  margin-top: -43px;
  padding: 5px 15px 15px 15px;
}
.iconthreet {
  display: block;
  margin-right: 3px;
  margin-top: 11px;
  float: left;
}
.icon-t {
  display: block;
  margin-left: 3px;
  margin-right: 16px;
  margin-top: -6px;
  float: left;
}
.iconpoint {
  display: block;
  margin-left: 16px;
  margin-right: -14px;
  margin-top: 7px;
  width: 27px;
  height: 27px;
  float: left;
  padding: 3px 3px 3px 3px;
}
hr.new4 {
  border: 1px solid #848484;
  height: 1px;
  border-radius: 73px;
}
.line-c {
  display: table;
  top: 34px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  border-radius: 30px;
  left: 0px;
}
.line-d {
  display: table;
  top: 34px;
  position: absolute;
  overflow: visible;
  border-radius: 30px;
  left: 211px;
  right: 40px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 30px;
  float: left;
}
.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  width: 100%;
  padding-right: var(--bs-gutter-x, 0.75rem);
  padding-left: var(--bs-gutter-x, 0.75rem);
  margin-right: auto;
  margin-left: 50px;
}
.btn-outline-success {
      font-family: 'Prompt';
  color: #7f8285;
  border-color: #963c3c00;
  font-weight: bold;
  width: 100%;
  float: right;
  font-size: 19px;
}
.btn-outline-secondary {
      font-family: 'Prompt';
  color: #7bc79a;
  border-color: #ffffff00;
  font-weight: bold;
  width: 100%;
  float: left;
  font-size: 19px;
}
.navbar {
  color: #ffffff;
}
.bg-dark {
  background-color: #ffffff !important;
  height: 100px;
}
.row {
  margin-right: 9px !important;
  margin-left: 18px !important;
}

.title-page-l {
  width: 100%;
  top: 20px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: Prompt Medium;
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;
      font-family: 'Prompt';
  letter-spacing: 2px;
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  text-align: left;
}
.title-page-r {
  top: 19px;
  position: absolute;
  overflow: visible;
  background: #ffffff;
  border-radius: 30px;
  width: 149px;
  left: 200px;
  height: 29px;
}
.title-page-r p {
  color: #7bc79a;
  padding-top: 10px;
  top: -14px;
}
.bg-white {
  background-color: #fff0 !important;
}
.bg-white.s {
  border-radius: 10px;
  height: 122px;
  width: 340px;
  position: relative;
  overflow: visible;
  margin-top: 20px;
  top: -6px;
}
.bg-white.ss {
  border-radius: 10px;
  height: 122px;
  width: 340px;
  position: relative;
  overflow: visible;
  margin-top: 20px;
}

h1 {
  font-size: 20px;
  margin-top: 12px;
  margin-left: 12px;
}
p {
    font-size: 13px;
    color: #7f8285;
    text-align: center;
    margin-left: -54px;
    margin-top: 7px;
}
.img-profile{
    display: block;
    width: 124px;
    height: 125px;
    float: left;
    margin-left: -15px;
    left: 0px;
    border-radius: 0;
        margin-top: 0px;
}
.name-status {
      font-family: 'Prompt';
  color: #7bc79a;
  margin-top: 13px;
  font-size: 0.6em;
  font-weight: bold;
}
.name-now {
      font-family: 'Prompt';
  color: #585858cb;
  margin-top: 13px;
  font-size: 0.8em;
  font-weight: bold;
  padding: 2px 2px 2px 23px;
}
.name-price {
  font-family: 'Prompt';
  color: #7bc79a;
  margin-top: 3px;
  font-size: 0.7em;
  padding: 0px 0px 0px 21px;
  display:block;
}
.name-product {
 font-family: 'Prompt';
  color: #000000;
  font-size: 0.8em;
  padding: 2px 2px 15px 21px;
}

.name-category {
  min-width: 100%;
  font-size: 0.5em;
  display: block;
  color: #030303;
}
.wordorder {
      font-family: 'Prompt';
  color: #000000;
  margin-top: 3px;
  font-size: 0.7em;
  padding: 0px 0px 0px 30px;
}
.pon {
  display: block;

  margin-right: 2px;
  margin-top: 8px;
  width: 33px;
  height: 33px;
  float: left;
}
.pon-t {
  display: block;
  margin-left: 3px;
  margin-right: 2px;
  width: 40px;
  height: 40px;
  float: left;
}
.progress {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress.s {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress-bar {
  background-color: #7bc79a;
  border-radius: 53px;
}
.progress-bar.s {
  background-color: #7bc79a;
  border-radius: 53px;
}
.row[data-v-eb54a8a2] {
    margin-bottom: 15px;
}
.row>* {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--bs-gutter-x)*0) !important;
    padding-left: calc(var(--bs-gutter-x)*0) !important;
    margin-top: var(--bs-gutter-y);
}
.fixios{
          -webkit-appearance: none;
-moz-appearance: none;
appearance: none;
background-color: transparent;
}

</style>
